// extracted by mini-css-extract-plugin
export default {"link":"link_link__3JSKB","name":"link_name__fM9if","date":"link_date__9TXu4"};